const Mn = require('backbone.marionette');
const Template = require('jiji/ui/template/content/admin/index.hbs');

module.exports = Mn.View.extend({
    template: Template
});



// WEBPACK FOOTER //
// ./jiji/ui/view/content/admin/index.js